export function decimalNormalizer (number) {
  return parseFloat(number).toFixed(2)
}
